import { render } from "./PlayerTile-v2.vue?vue&type=template&id=2d622c46"
import script from "./PlayerTile-v2.vue?vue&type=script&lang=js"
export * from "./PlayerTile-v2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__